import { AxiosResponse } from 'axios';
import { Responses } from 'constants/responses';
import { ApiClientError } from 'api/client';

export function isUnauthorizedApiClientError(error: unknown): boolean {
  if (!(error instanceof ApiClientError)) {
    return false;
  }
  const statusFromAxiosError = error.axiosError?.response?.status;
  const responsePayload = error.response as AxiosResponse | undefined;
  const statusFromResponsePayload =
    typeof responsePayload?.status === 'number'
      ? responsePayload.status
      : undefined;
  const status = statusFromAxiosError ?? statusFromResponsePayload;
  return status === Responses.ERROR.UNAUTHORIZED;
}
